// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import "./App.css";
var qs = require("qs");

/**
 * This component is used to display the required
 * privacy statement which can be found in a link in the
 * about tab.
 */
class OAuthCallback extends React.Component {
  async componentDidMount() {
    await microsoftTeams.app.initialize();

    // It should be location.search, but they're sending the params back with a '#' instead of a '?', instead.
    const response = qs.parse(this.props.location.hash.replace(/^#/, ''))

    if (response.error) {
      microsoftTeams.authentication.notifyFailure(response.error);
    }

    localStorage.removeItem("simple.error");
    if (response.error) {
      // Authentication/authorization failed
      console.log("response", response);
      localStorage.setItem("simple.error", JSON.stringify(response));
      microsoftTeams.authentication.notifyFailure(response.error);
    } else if (response.access_token) {
      // Get the stored state parameter and compare with incoming state
      let expectedState = localStorage.getItem("simple.state");
      if (expectedState !== response.state) {
        // State does not match, report error
        localStorage.setItem("simple.error", JSON.stringify(response));
        microsoftTeams.authentication.notifyFailure("StateDoesNotMatch");
      } else {
        // Success -- return token information to the parent page
        microsoftTeams.authentication.notifySuccess(response);
      }
    } else {
      // Unexpected condition: hash does not contain error or access_token parameter
      console.log("response", response);
      localStorage.setItem("simple.error", JSON.stringify(response));
      microsoftTeams.authentication.notifyFailure("UnexpectedFailure");
    }
  }

  render() {
    return null;
  }
}

export default OAuthCallback;
